import styled from 'styled-components';
export const StyledClearSearchButton = styled.button.withConfig({
  displayName: "StyledClearSearchButton",
  componentId: "sc-1ewlj8-0"
})(["padding:0 !important;margin:0 !important;border:0 !important;background:none !important;width:14px;height:14px;display:flex;align-items:center;justify-content:center;"]);